import styled from "@emotion/styled";
export const StyledStructuredHeader = styled.nav`
  .menu-component-wrapper.short-menu {
    margin: auto;
    width: fit-content;
    flex-shrink: 0;
  }
`;
